import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import MentalHealth from './components/MentalHealth';
import ChildrenBenefit from './components/ChildrenBenefit';
import OlderChildren from './components/OlderChildren';

const BehavioralHealth = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Pediatric Behavioral Therapy Wasilla Alaska | Guidepost Behavioral
          Health
        </title>
        <meta
          name="description"
          content="Pediatric behavioral therapy services in Wasilla, Alaska. Our behavioral health specialists help children with emotional regulation, social skills, and mental health support."
        />
        <meta
          name="keywords"
          content="pediatric behavioral therapy Wasilla, behavioral health Alaska, child mental health Wasilla, behavioral therapy for children"
        />
      </Helmet>
      <HeroSection />
      <MentalHealth />
      <ChildrenBenefit />
      <OlderChildren />
    </div>
  );
};

export default BehavioralHealth;
